export default "__VITE_ASSET__cEoOtAPr__"